const usedAElements = new Set();

export const run = () => {
  document.querySelectorAll('a[data-layer-click-event]').forEach(a => {
    if (!usedAElements.has(a)) {
      usedAElements.add(a);
      const event = JSON.parse(decodeURIComponent(a.dataset.layerClickEvent));
      a.addEventListener('click', () => window.dataLayer.push(event));
    }
  });
};

export const dataLayerClickService = {
  init: () => {
    run();
    // Event triggered by transporter
    document.addEventListener('onRouteUpdate', run, {
      passive: true
    });
  },
  run
};
